import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
    FaTh,
    FaBox,
    FaShoppingCart,
    FaCog,
    FaBars,
  } from 'react-icons/fa';

const Sidebar = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setIsCollapsed(true);
            } else {
                setIsCollapsed(false);
            }
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => window.removeEventListener("resize", handleResize);
    }, []);


    return (
        <aside className={`${isCollapsed ? "w-16" : "w-64"} bg-white shadow-lg transition-all duration-300`}>
            <div className={`p-4 flex ${isCollapsed ? "justify-center" : "justify-between"} items-center`}>
                {!isCollapsed && (
                    <h2 className="text-xl font-bold text-gray-800">Admin Panel</h2>
                )}
                
                <button
                    onClick={toggleSidebar}
                    className="flex items-center justify-center text-gray-700 hover:text-gray-900 focus:outline-none"
                >
                    <FaBars size={20} color='#333' />
                </button>
            </div>

            <nav className='mt-6 '>
                <SidebarLink to="/" icon={<FaTh size={20} />} text="Dashboard" isCollapsed={isCollapsed} />
                <SidebarLink to="/products" icon={<FaBox size={20} />} text="Produkter" isCollapsed={isCollapsed} />
                <SidebarLink to="/orders" icon={<FaShoppingCart size={20} />} text="Ordre" isCollapsed={isCollapsed} />
                <SidebarLink to="/settings" icon={<FaCog size={20} />} text="Instillinger" isCollapsed={isCollapsed} />
            </nav>
        </aside>
    )
}

const SidebarLink = ({ to, icon, text, isCollapsed }) => {
    return (
        <Link
            to={to}
            className={`flex items-center px-4 py-4 text-gray-700 hover:bg-gray-100 transition-all ${
                isCollapsed ? "justify-center" : "justify-start"
            }`}
        >
            <div className='mx-3'>{icon}</div>
            {!isCollapsed && <span className=''>{text}</span>}
        </Link>
    )
}

export default Sidebar